import { Trade } from '@mkrman/sdk'
import {
  Button,
  BlockIcon,
  Box,
  Flex,
  Link,
  LinkExternal,
  Text,
  LineGraphIcon,
  useMatchBreakpointsContext,
} from '@pancakeswap/uikit'
import { baseColors, darkColors, lightColors } from '@pancakeswap/uikit/src/theme/colors'
import { RowFixed } from 'components/Layout/Row'
import QuestionHelper from 'components/QuestionHelper'
// import TradingView, { useTradingViewEvent } from 'components/TradingView'
import { useTranslation } from 'contexts/Localization'
import useDebounce from 'hooks/useDebounce'
import { usePairs } from 'hooks/usePairs'
import useTotalSupply from 'hooks/useTotalSupply'
import { useCallback, useEffect, useMemo, useState, memo } from 'react'
// import { setChartView } from 'state/predictions'
import fetchPairPriceData from 'state/swap/fetch/fetchPairPriceData'
import { useFetchPairPrices, usePairHasEnoughLiquidity } from 'state/swap/hooks'
import { PairDataTimeWindowEnum } from 'state/swap/types'
import { ChartViewMode } from 'state/user/actions'
import { useTokenBalances } from 'state/wallet/hooks'
import styled from 'styled-components'
import { CandleChartLoader } from 'views/Info/components/ChartLoaders'
import TradingViewWarning from '../TradingViewWarning'
import NoChartAvailable from './NoChartAvailable'

interface TradingViewChartProps {
  token0Address
  token1Address
  currentSwapPrice
  isDark?: boolean
  isExpanded?: boolean
}

const ChartButton = styled(Button)`
  border: 2px solid transparent;
  ${({ $active, theme }) => $active && `border: 2px solid ${theme.colors.primary}4b`};
  padding: 4px 10px;
  border-radius: 10px;
`

const TradingViewWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 8px;
  @media all and (max-width: 574px){
    height: Calc(100% - 18px);
  }
`

const DexScreenerBox = styled(Box)`
  display: block;
  float: left;
  font-size: 12px;
  z-index: 10;
  margin: -51px 0 0 352px;
  @media all and (max-width: 1199px) {
    display: none;
  }
  svg {
    width: 12px;
  }
`

const DerivedLiquidityBox = styled(Box)`
  display: block;
  float: left;
  font-size: 12px;
  z-index: 10;
  margin: -51px 0 0 352px;
  @media all and (max-width: 1199px) {
    display: none;
  }
`

const ChartNotAvailable = styled.div`
  display: flex;
  position: relative;
  height: Calc(100% - 60px);
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 2;
`

const LoadingWrapper = styled.div<{ $isDark: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 3;
  background: ${({ theme }) => theme.colors.backgroundAlt};

  ${({ theme }) => theme.mediaQueries.md} {
    background: ${({ theme }) => theme.colors.backgroundAlt};
  }
`

const DelayedLoadingWrapper = styled(LoadingWrapper)`
  height: Calc(100% - 60px);
  animation: css-hide-chart 0s 2.5s forwards;
`

/* 
const avaxToWAVAXSymbol = (sym: string) => (sym === 'AVAX' ? 'WAVAX' : sym)

const ID = 'TV_SWAP_CHART'
const SYMBOL_PREFIX = 'TRADERJOE:'
*/

const TradingViewChart = ({
  token0Address,
  token1Address,
  currentSwapPrice,
  isDark,
  isExpanded,
}: TradingViewChartProps) => {
  const [chartIsLoading, setChartIsLoading] = useState(true)
  const { t } = useTranslation()
  const [reload, setReload] = useState(false)
  const { isMobile } = useMatchBreakpointsContext()
  const [timeWindow, setTimeWindow] = useState<PairDataTimeWindowEnum>(0)

  const { pairId } = useFetchPairPrices({
    token0Address,
    token1Address,
    timeWindow,
    currentSwapPrice,
  })

  const hasEnoughLiquidity = usePairHasEnoughLiquidity(pairId, timeWindow)

  const chartHeight = isMobile ? 'Calc(100% - 12px)' : 'Calc(100% - 22px)'

  /*
  if ( outputCurrency && !pairPrices )  {
    return <NoChartAvailable 
      token0Address={token1Address}
      token1Address={token0Address}
      pairAddress={pairId}
      isMobile
      />
  }
  */

  /*
  const totalSupply = useTotalSupply(pair?.liquidityToken)
  const totalSupply = useTotalSupply(pair?.liquidityToken)
  */

  /* 
  const symbol = useMemo(() => {
    if (!(inputSymbol && outputSymbol)) {
      return null
    }

    const input = avaxToWAVAXSymbol(inputSymbol)
    const output = avaxToWAVAXSymbol(outputSymbol)
    
    return `${output}${input}` // switching the order here has resulted in a better chart
  }, [outputSymbol, inputSymbol])
  */
  /*
  const onNoDataEvent = useCallback(() => {
    console.debug('No data from TV widget')
    setHasNoData(true)
  }, [])

  const onLoadedEvent = useCallback(() => {
    setIsLoading(false)
  }, [])

  useTradingViewEvent({
    id: ID,
    onNoDataEvent,
    onLoadedEvent,
  })

  // debounce the loading to wait for no data event from TV widget.
  // we cover the loading spinner over TV, let TV try to load data from pairs
  // if there's no no-data event coming between the debounce time, we assume the chart is loaded
  const debouncedLoading = useDebounce(isLoading, 800)

  useEffect(() => {
    if (!(isLoading || debouncedLoading) && !hasNoData && symbol) {
      onTwChartSymbol(symbol)
    } else {
      onTwChartSymbol('')
    }
  }, [debouncedLoading, hasNoData, isLoading, onTwChartSymbol, symbol])
  */

  return (
    <TradingViewWrapper>
      {/* 
      <DEXScreenerLink
        id="dexscreener-link"
        href={`https://dexscreener.com/avalanche/${pairId}`}
        mt={['-46px', '-46px', isExpanded ? '-46px' : '-46px']}
        ml={['328px', '328px', '328px']}
        color={ isDark ? darkColors.textSubtle : lightColors.textSubtle }
      >
        {t('DEX Screener')}
      </DEXScreenerLink> */}

      {hasEnoughLiquidity === true && (
        <DexScreenerBox>
          <LinkExternal
            href={`https://dexscreener.com/avalanche/${pairId}`}
            color={isDark ? darkColors.textSubtle : lightColors.textSubtle}
            target="_blank"
            style={{ lineHeight: '1.5', fontSize: '14px' }}
          >
            {t('DEX Screener')}
          </LinkExternal>
        </DexScreenerBox>
      )}

      {hasEnoughLiquidity === false && (
        <DexScreenerBox>
          <LinkExternal
            href={`https://dexscreener.com/avalanche/${token0Address}`}
            color={isDark ? darkColors.textSubtle : lightColors.textSubtle}
            target="_blank"
            style={{ lineHeight: '1.5', fontSize: '14px' }}
          >
            {t('Pair N/A (Derived)')}
          </LinkExternal> 
          </DexScreenerBox>
      )}

      {chartIsLoading && (
        <DelayedLoadingWrapper $isDark={isDark} style={{ display: 'block' }}>
          <CandleChartLoader />
        </DelayedLoadingWrapper>
      )}

      {/*
        <ChartNotAvailable>
          <Text fontSize="14px" color="text" mt="-40px" >
            {t('TradingView chart must be a direct-route pair.')}
          </Text>
        </ChartNotAvailable>
      */}

      {/*
      {!hasNoData && (
        <TradingViewWrapper $show={!isLoading}>
          {symbol && <TradingView id={ID} symbol={`${SYMBOL_PREFIX}${symbol}`} />}
        </TradingViewWrapper>
      )} */}
      <div
        id="dexscreener-embed"
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <iframe
          title="dexscreener-chart"
          style={{
            position: 'absolute',
            width: '100%',
            height: chartHeight,
            top: '0',
            left: '0',
            border: '0',
            background: '#131722',
          }}
          src={
            hasEnoughLiquidity === true
              ? `https://dexscreener.com/avalanche/${pairId}?embed=1&theme=dark&trades=0&info=0`
              : `https://dexscreener.com/avalanche/${token0Address}?embed=1&theme=dark&trades=0&info=0`
          }
        />
        {/* Link structure: https://dexscreener.com/avalanche/PAIR?embed=1&theme=dark&trades=0&info=0 */}
      </div>
    </TradingViewWrapper>
  )
}

export default TradingViewChart
